import { render, staticRenderFns } from "./communication.vue?vue&type=template&id=7ecf59ef&scoped=true"
import script from "./communication.vue?vue&type=script&lang=js"
export * from "./communication.vue?vue&type=script&lang=js"
import style0 from "./communication.vue?vue&type=style&index=0&id=7ecf59ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecf59ef",
  null
  
)

export default component.exports